import { DOMAIN, UsageAccessTypes, ZIndexType } from '../../consts';

import strings from '../../strings';
import React from 'react';

export function formattedDateShortMonth(date: Date): string {
  return date?.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  });
}

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
};

export const isAdmin = () => {
  return DOMAIN === 'admin';
};

export const getLastElementString = (path?: string): string => {
  return path?.split('/').pop() || '';
};

export const stringWithVerticalColon = (string: string): string => {
  return `${string}${strings.verticalColon}`;
};

export const blurModal = () => {
  const modals = document.querySelectorAll('.modal-dialog');
  if (modals.length > 0) {
    modals.forEach((modal, index) => {
      if (modal.parentElement) {
        const parent = modal.parentElement;
        const isLastModal = index === modals.length - 1;
        parent.style.zIndex = isLastModal
          ? ZIndexType.Z_INDEX_DEFAULT
          : ZIndexType.Z_INDEX_BLUR;
      }
    });
  }
};

export function getPercent(a: number, sum: number) {
  return ((a / sum) * 100).toFixed(2);
}

export function convertToTitleCase(inputString: string) {
  return (
    inputString.toLowerCase().charAt(0).toUpperCase() +
    inputString.slice(1).toLowerCase()
  );
}

export function parseDateTimeToString(date: Date): string {
  return (
    new Date(date).toLocaleDateString() +
    ' ' +
    new Date(date).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    })
  );
}

export function sortBy<T>(a: T | string, b: T | string, key?: keyof T): number {
  const valueA = key
    ? String((a as T)[key]).toLowerCase()
    : String(a).toLowerCase();
  const valueB = key
    ? String((b as T)[key]).toLowerCase()
    : String(b).toLowerCase();

  if (valueA > valueB) {
    return 1;
  }
  if (valueA < valueB) {
    return -1;
  }
  return 0;
}

export function setUsageAccessLabel(label: string) {
  switch (label) {
    case UsageAccessTypes.AUTHORIZED_USER_COUNT:
      return strings.pageAdminOrganizationReportAuthorizedUsers;
    case UsageAccessTypes.COUNT_AMOUNT:
      return strings.pageAdminOrganizationReportSecureContainers;
    case UsageAccessTypes.COUNT_DATE:
      return strings.pageAdminOrganizationReportDate;
    case UsageAccessTypes.LOCATION_ACCESS:
      return strings.pageAdminOrganizationReportLocationAccess;
    case UsageAccessTypes.PREVENT_COPY_COUNT:
      return strings.pageAdminOrganizationReportPreventCopy;
    case UsageAccessTypes.PREVENT_FORWARD_COUNT:
      return strings.pageAdminOrganizationReportPreventForward;
    case UsageAccessTypes.PREVENT_PRINT_COUNT:
      return strings.pageAdminOrganizationReportPreventPrint;
    case UsageAccessTypes.PREVENT_SAVE_COUNT:
      return strings.pageAdminOrganizationReportPreventSave;
    case UsageAccessTypes.REVOKE_COUNT:
      return strings.pageAdminOrganizationReportRevoke;
    case UsageAccessTypes.SHRED_COUNT:
      return strings.pageAdminOrganizationReportShred;
    case UsageAccessTypes.ACCESS_TIME:
      return strings.pageAdminOrganizationReportAccessTimes;
    default:
      return label;
  }
}

export function byteToMB(value: number | string) {
  const valueToNumber = parseFloat(String(value));
  if (isNaN(valueToNumber) || valueToNumber < 0) {
    return 'Invalid input';
  }

  const KB_THRESHOLD = 1048576; // 1024 * 1024

  if (valueToNumber < KB_THRESHOLD) {
    return `${(valueToNumber / 1024).toFixed(3)} KB`;
  }

  return `${(valueToNumber / 1048576).toFixed(3)} MB`;
}

export const RenderEllipsisTextTooltip = (
  value: string | null
): JSX.Element => {
  return value === '' || value === null ? (
    <div></div>
  ) : (
    <div className="wrap-text-ellipsis">
      <div className="text-ellipsis" data-bs-toggle="tooltip" title={value}>
        {value}
      </div>
    </div>
  );
};
